import {
  Boxes,
  ListChecks,
  MessageSquare,
  ChartNoAxesColumn,
  Search,
  ShieldCheck,
  UploadCloud,
  Activity,
  type LucideIcon,
} from 'lucide-react';

export interface HelpFeature {
  id: string;
  icon: LucideIcon;
  titleKey: string;
  descriptionKey: string;
}

export const HELP_FEATURES: HelpFeature[] = [
  { id: 'search', icon: Search, titleKey: 'help.features.search', descriptionKey: 'help.features.searchDesc' },
  { id: 'upload', icon: UploadCloud, titleKey: 'help.features.upload', descriptionKey: 'help.features.uploadDesc' },
  { id: 'chat', icon: MessageSquare, titleKey: 'help.features.chat', descriptionKey: 'help.features.chatDesc' },
  { id: 'drbfm', icon: ChartNoAxesColumn, titleKey: 'help.features.drbfm', descriptionKey: 'help.features.drbfmDesc' },
  { id: 'verification', icon: ListChecks, titleKey: 'help.features.verification', descriptionKey: 'help.features.verificationDesc' },
  { id: 'cad', icon: Boxes, titleKey: 'help.features.cad', descriptionKey: 'help.features.cadDesc' },
  { id: 'audit', icon: Activity, titleKey: 'help.features.audit', descriptionKey: 'help.features.auditDesc' },
  { id: 'security', icon: ShieldCheck, titleKey: 'help.features.security', descriptionKey: 'help.features.securityDesc' },
];

/** Each id resolves to help.faq.<id>Question / <id>Answer, and tints its badge. */
export const HELP_FAQ_IDS = [
  'search',
  'upload',
  'category',
  'chat',
  'chatFileScope',
  'drbfm',
  'verification',
  'cad',
  'audit',
  'security',
] as const;

export type HelpFaqId = (typeof HELP_FAQ_IDS)[number];

export const HELP_TIP_KEYS = ['help.tip1', 'help.tip2', 'help.tip3', 'help.tip4', 'help.tip5'];

export const HELP_CONTACT_EMAIL = 'info@aiona.co.jp';
